export default "__VITE_ASSET__b602e039__"